import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { COMPANY, NAV } from './content';

/**
 * Public marketing shell: header with navigation, routed page, footer.
 *
 * Separate from the signed-in app's <Layout>, which has a different nav and
 * assumes an authenticated user. Sharing one would mean a component that
 * branches on auth state in every row of the menu.
 */
export function SiteLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Navigating on a phone must close the menu, or the new page renders
  // underneath an open overlay.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  // A route change should land you at the top of the new page, not at the
  // scroll offset of the previous one.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="site">
      <header className="site-top">
        <div className="site-top-inner">
          <Link to="/" className="brand site-brand">
            Apex<span>Flow</span>
          </Link>

          <button
            className="ghost sm site-burger"
            aria-expanded={menuOpen}
            aria-controls="site-nav"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>

          <nav
            id="site-nav"
            className={menuOpen ? 'site-nav open' : 'site-nav'}
          >
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end}>
                {n.label}
              </NavLink>
            ))}
            <a className="site-cta" href={`mailto:${COMPANY.email}`}>
              Get a quote
            </a>
          </nav>
        </div>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-foot">
        <div className="site-foot-inner">
          <div>
            <div className="brand">
              Apex<span>Flow</span>
            </div>
            <p className="site-foot-note">{COMPANY.tagline}</p>
          </div>
          <nav className="site-foot-nav">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to}>
                {n.label}
              </Link>
            ))}
          </nav>
          <div className="site-foot-contact">
            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
            <span className="site-foot-note">
              &copy; {new Date().getFullYear()} {COMPANY.name}
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}
